import React from 'react';
import { Link } from 'react-router-dom';
import { Store, ShoppingCart, DollarSign, Clock } from 'lucide-react';
import { Container } from '../Container';
import { motion } from 'framer-motion';
export function TeamStoresSection() {
  return <section className="py-20 bg-gray-50" data-id="element-237">
      <Container data-id="element-238">
        <div className="flex flex-col lg:flex-row-reverse items-center gap-12" data-id="element-239">
          <div className="lg:w-1/2" data-id="element-240">
            <h2 className="font-oswald text-4xl md:text-5xl font-bold uppercase mb-6 text-gray-900" data-id="element-241">
              Team Stores That Help Fans Order and Teams Raise Funds
            </h2>
            <div className="w-24 h-1.5 bg-pts-red mb-6" data-id="element-242"></div>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-243">
              Create a custom team store with gear featuring your organization's
              colors and logo. Families, fans, and supporters can order
              individually during a store window, and the organization can use
              markup options for fundraising.
            </p>

            <div className="space-y-6 mb-10" data-id="element-244">
              <div className="flex items-start" data-id="element-245">
                <div className="bg-red-50 p-3 rounded-full text-pts-red mr-4 mt-1" data-id="element-246">
                  <ShoppingCart className="h-6 w-6" data-id="element-247" />
                </div>
                <div data-id="element-248">
                  <h4 className="font-oswald text-xl font-bold uppercase text-gray-900" data-id="element-249">
                    Custom Gear for Fans & Families
                  </h4>
                  <p className="text-gray-600" data-id="element-250">
                    Offer a wide selection of branded apparel without managing
                    inventory.
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-251">
                <div className="bg-red-50 p-3 rounded-full text-pts-red mr-4 mt-1" data-id="element-252">
                  <Clock className="h-6 w-6" data-id="element-253" />
                </div>
                <div data-id="element-254">
                  <h4 className="font-oswald text-xl font-bold uppercase text-gray-900" data-id="element-255">
                    Online Ordering Window
                  </h4>
                  <p className="text-gray-600" data-id="element-256">
                    Set a specific timeframe for orders, then we produce and
                    ship everything together.
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-257">
                <div className="bg-red-50 p-3 rounded-full text-pts-red mr-4 mt-1" data-id="element-258">
                  <DollarSign className="h-6 w-6" data-id="element-259" />
                </div>
                <div data-id="element-260">
                  <h4 className="font-oswald text-xl font-bold uppercase text-gray-900" data-id="element-261">
                    Fundraising Markup Options
                  </h4>
                  <p className="text-gray-600" data-id="element-262">
                    Add a markup to items in your store to easily raise money
                    for your program.
                  </p>
                </div>
              </div>
            </div>

            <Link to="/team-stores" className="inline-flex items-center bg-gray-900 hover:bg-gray-800 text-white px-8 py-4 rounded font-bold uppercase tracking-wide text-lg transition-colors" data-id="element-263">
              Learn About Team Stores
            </Link>
          </div>

          <div className="lg:w-1/2 w-full" data-id="element-264">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="relative" data-id="element-265">
              <div className="absolute -inset-4 bg-pts-red/10 rounded-2xl transform -rotate-3 z-0" data-id="element-266"></div>
              <img src="https://images.unsplash.com/photo-1556906781-9a412961c28c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Online Team Store Mobile View" className="relative z-10 w-full h-auto rounded-xl shadow-xl border border-gray-200" data-id="element-267" />
            </motion.div>
          </div>
        </div>
      </Container>
    </section>;
}